import {
  ChartBar,
  ChatCircle,
  Users,
  Funnel,
  Gear,
  BellRinging,
  CalendarBlank,
  ChartPie,
  EnvelopeSimple,
  PhoneCall,
  Fire,
  Robot,
  Car,
  Sword,
  Trophy,
  Sparkle,
  Receipt,
  Chalkboard,
  Scales,
} from '@phosphor-icons/react';

// Dealer Portal navigation — restructured for clarity
export const navGroups = [
  {
    label: 'Workspace',
    items: [
      { path: '/dashboard', icon: ChartBar, label: 'Dashboard' },
      { path: '/inbox', icon: ChatCircle, label: 'Inbox', badge: true },
      { path: '/calendar', icon: CalendarBlank, label: 'Calendar' },
      { path: '/pipeline', icon: Funnel, label: 'Pipeline' },
    ]
  },
  {
    label: 'Sales',
    items: [
      { path: '/contacts', icon: Users, label: 'Contacts' },
      { path: '/followups', icon: BellRinging, label: 'Action Center', badge: true },
      { path: '/appraisals', icon: Scales, label: 'Appraisals', badge: true, badgeKey: 'pending_appraisals' },
      { path: '/campaigns', icon: EnvelopeSimple, label: 'Campaigns' },
    ]
  },
  {
    label: 'Inventory',
    items: [
      { path: '/inventory', icon: Car, label: 'Inventory' },
      { path: '/competitors', icon: Sword, label: 'Competitors', advanced: true },
    ]
  },
  {
    label: 'Insights',
    items: [
      { path: '/leaderboard', icon: Trophy, label: 'Leaderboard' },
      { path: '/sales-coach', icon: Chalkboard, label: 'AI Coach' },
      { path: '/reports', icon: ChartPie, label: 'Reports', advanced: true },
    ]
  },
  {
    label: 'Manage',
    items: [
      { path: '/add-ons', icon: Sparkle, label: 'Add-Ons', badge: true, badgeKey: 'addons' },
      { path: '/billing', icon: Receipt, label: 'Billing', managerOnly: true },
      { path: '/settings', icon: Gear, label: 'Settings' },
    ]
  },
];

// Flatten for filtering
export const navItems = navGroups.flatMap(g => g.items);

// Notification icon/color maps
export const NOTIF_ICONS = {
  message: ChatCircle,
  robot: Robot,
  phone: PhoneCall,
  fire: Fire,
  bell: BellRinging,
};

export const NOTIF_COLORS = {
  new_message: { bg: 'from-blue-500 to-blue-600', ring: 'ring-blue-500/20' },
  ai_response: { bg: 'from-orange-400 to-orange-500', ring: 'ring-orange-500/20' },
  call_request: { bg: 'from-red-500 to-rose-600', ring: 'ring-red-500/20' },
  hot_lead: { bg: 'from-amber-400 to-orange-500', ring: 'ring-amber-500/20' },
  followup_due: { bg: 'from-violet-500 to-purple-600', ring: 'ring-violet-500/20' },
};
